import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-setting-submenu-popover',
  templateUrl: './setting-submenu-popover.component.html',
  styleUrls: ['./setting-submenu-popover.component.scss'],
})
export class SettingSubmenuPopoverComponent  implements OnInit {

  constructor(private popoverCtrl: PopoverController) { }

  ngOnInit() {}

  select(option: string) {
    console.log('Selected:', option);
    this.popoverCtrl.dismiss(option);
  }

}
